import { BoolPropertyViewModel, CustomPropertyViewModelDecorator, Filter, InternalViewModelTypeDecorator, NNumericPropertyViewModel, StringDecorator } from "@nts/std";
import { OrderBy } from "@nts/std";
import { ExternalDomainModelTypeDecorator, ExternalDomainModelTypeNameDecorator, ExternalViewModel, IdentityTypeDecorator, NumericPropertyViewModel, StringPropertyViewModel } from "@nts/std";
import { map, Observable, tap } from "rxjs";
import { Currency } from "src/app/external-remote/currency/currency";
import { CurrencyIdentity } from "src/app/external-remote/currency/currency.identity";
import { CurrencyBusinessDataViewModel } from "src/app/external-remote/currency/view-models/currency-business-data.view-model";
import { ExpenseDataViewModel } from "./expense-data.view-model";
import { ReceiptLongOpOrchestratorViewModel } from "./receipt-long-op.orchestrator-view-model";
import { CurrencyUtils } from "src/app/shared/utils/currency-utils";
import { BigNumber, FilterOperators, WhereOperators } from "@nts/std/types";
@IdentityTypeDecorator(CurrencyIdentity)
@ExternalDomainModelTypeDecorator(Currency)
@ExternalDomainModelTypeNameDecorator('Currency')
export class CurrencyExtViewModel extends ExternalViewModel<Currency, CurrencyIdentity> {

  // tslint:disable-next-line: variable-name
  private _id: NNumericPropertyViewModel;

  get id(): NNumericPropertyViewModel {
    return this.getNNumericPropertyViewModel((value) => { this._id = value; }, this._id, 'id');
  }

  // tslint:disable-next-line: variable-name
  private _description: StringPropertyViewModel;

  get description(): StringPropertyViewModel {
    return this.getStringPropertyViewModel((value) => { this._description = value; }, this._description, 'description');
  }

  private _name: StringPropertyViewModel;

  get name(): StringPropertyViewModel {
    return this.getStringPropertyViewModel((value) => { this._name = value; }, this._name, 'name');
  }

  private _isoCode: StringPropertyViewModel;

  get isoCode(): StringPropertyViewModel {
    return this.getStringPropertyViewModel((value) => { this._isoCode = value; }, this._isoCode, 'isoCode');
  }

  private _symbol: StringPropertyViewModel;

  get symbol(): StringPropertyViewModel {
    return this.getStringPropertyViewModel((value) => { this._symbol = value; }, this._symbol, 'symbol');
  }

  private _isDefault: BoolPropertyViewModel;

  get isDefault(): BoolPropertyViewModel {
    return this.getBoolPropertyViewModel((value) => { this._isDefault = value; }, this._isDefault, 'isDefault');
  }

  @InternalViewModelTypeDecorator(CurrencyBusinessDataViewModel)
  public businessData: CurrencyBusinessDataViewModel;

  private _customValue: StringPropertyViewModel;

  @CustomPropertyViewModelDecorator()
  @StringDecorator({ displayNameKey: 'customValue' })
  public get customValue(): StringPropertyViewModel {
    if (this._customValue == null) {
      this._customValue = this.getStringPropertyViewModel((value) => {
        this._customValue = value;
      },
        this._customValue,
        'customValue',
        () => CurrencyUtils.getCurrencySymbol(this.domainModel) ?? this?.domainModel?.description
      );
    }
    return this._customValue;
  }

  override async postInit() {
    await super.postInit();
    this.additionalOutputProperties = ['IsDefault', 'BusinessData.BusinessCode', 'Description'];

    const filterBarcode99 = new Filter();
    filterBarcode99.name = 'BusinessData.BusinessCode';
    filterBarcode99.operator = FilterOperators.NotEquals;
    filterBarcode99.value = 99;

    const filterBarcode100 = new Filter();
    filterBarcode100.name = 'BusinessData.BusinessCode';
    filterBarcode100.operator = FilterOperators.NotEquals;
    filterBarcode100.value = 100;

    this.additionalFilters = [filterBarcode99, filterBarcode100];

    // this.decodeProperties = ['customValue'];
    // this.autocompleteProperties = ['customValue'];

    this.decodeProperties = ['Description'];
    this.autocompleteProperties = ['Description'];
  }

  // override get formattedValue() {
  //   return CurrencyUtils.getCurrencySymbol(this.domainModel);
  // }

  protected override parseAutocompleteDataFromPropertyArray(properties: Array<string | number | BigNumber>, showCodeInDescription: boolean, outputProperties: string[], basePlainPascalCaseFixedIdentity: { [key: string]: string | number | BigNumber; } | null, decodeProperties?: string[], fieldSeparator?: string | undefined): { description: string; identity: { [key: string]: string | number | BigNumber; }; all: any; } {
    const ovm = this.externalRetriever as ReceiptLongOpOrchestratorViewModel;
    if (!ovm.onlineService.isOnline) {
      outputProperties = ['Id', 'IsoCode', 'Name', 'IsDefault', 'BusinessData.BusinessCode', 'Description', 'Symbol'];
    }
    return super.parseAutocompleteDataFromPropertyArray(properties, showCodeInDescription, outputProperties, basePlainPascalCaseFixedIdentity, decodeProperties, fieldSeparator);
  }



  //card #4534 -> prima di tornare il risultato della chiamata per impostare l'external list,
  //mi sottoscrivo al risultato di quella chiamata e setto come valore della external l'id della valuta
  //che  ha il flag IsDefault.
  override execExternalList(_languageCode?: string, showCodeInDescription?: boolean, basePlainPascalCaseFixedIdentity?: any, decodeProperties?: string[] | null, orderByPropertyNames?: OrderBy[] | null, additionalFilters?: Filter[] | null, fieldSeparator?: string | undefined): Observable<{ description: string; identity: { [key: string]: string | number | BigNumber; }; all: { [key: string]: string | number | BigNumber; }[]; }[]> {
    return super.execExternalList(
      _languageCode,
      showCodeInDescription,
      basePlainPascalCaseFixedIdentity,
      decodeProperties,
      orderByPropertyNames,
      additionalFilters,
      fieldSeparator
    ).pipe(
      tap(result => {
        const defaultCurrency = result.find(currencies => currencies.all.find(currency => currency['IsDefault']))

        const parent = this.parent as ExpenseDataViewModel;

        let useDefaultCurrency = true;
        if (parent && parent?.configuration) {
          useDefaultCurrency = !parent?.configuration?.manageCurrency;
        }

        if (defaultCurrency != undefined && useDefaultCurrency) {
          this.setCodeValue(defaultCurrency.identity['Id'])
          //#5329 -> se riesco a settare una valuta default blocco il campo valuta.
          this.isEnabled = false;
        }

        if (!this.id.value && this.isEnabled) {
          this.setCodeValue(defaultCurrency.identity['Id'])
        }
      }),
      map(result => {
        return result.filter(currencies => {
          const businessCodeObject = currencies.all.find(currency =>
            currency['BusinessData.BusinessCode']
          );
          const businessCode = businessCodeObject?.['BusinessData.BusinessCode'];
          return businessCode !== 99 && businessCode !== 100;
        });
      })
    );
  }
}
